import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation, useParams } from 'react-router-dom';
import { TransitionProvider, useTransition } from './components/common/Transition/TransitionContext';
import { ViewProvider } from './components/common/View/ViewContext';
import TransitionOverlay from './components/common/Transition/TransitionOverlay';
import Header from './components/common/Header/Header';
import Footer from './components/common/Footer/Footer';
import Layout from './components/common/Layout/Layout';
import Home from './components/pages/Home/Home';
import ProjectCarousel from './components/pages/ProjectCarousel/ProjectCarousel';
import ProfilePage from './components/pages/Profile/Profile';
import './App.css';

// ヘッダー・フッターラッパーコンポーネント
const HeaderFooterWrapper: React.FC = () => {
  const location = useLocation();
  const { projectId } = useParams(); // プロジェクトIDを取得
  const { shouldUseWhiteText, shouldFadeOutText } = useTransition();
  
  // 現在のページタイプを判定
  let currentPage: 'home' | 'project' | 'profile' = 'home';
  if (location.pathname.startsWith('/project')) {
    currentPage = 'project';
  } else if (location.pathname === '/profile') {
    currentPage = 'profile';
  }
  
  console.log('🎯 HeaderFooterWrapper - currentPage:', currentPage, 'projectId:', projectId, 'shouldUseWhiteText:', shouldUseWhiteText, 'shouldFadeOutText:', shouldFadeOutText);
  console.log('🔍 HeaderFooterWrapper useParams debug:', { 
    projectId, 
    projectIdType: typeof projectId, 
    locationPathname: location.pathname,
    paramsObject: useParams()
  });
  
  // クラス名の組み立て（ホームページでのフェードアウトのみ）
  const getHeaderClasses = () => {
    const classes = ['fixed-header'];
    if (shouldUseWhiteText) classes.push('transition-white-text');
    if (shouldFadeOutText && currentPage === 'home') classes.push('transition-fade-out');
    return classes.join(' ');
  };

  const getFooterClasses = () => {
    const classes = ['fixed-footer'];
    if (shouldUseWhiteText) classes.push('transition-white-text');
    if (shouldFadeOutText && currentPage === 'home') classes.push('transition-fade-out');
    return classes.join(' ');
  };
  
  return (
    <>
      {/* 固定ヘッダー */}
      <div className={getHeaderClasses()}>
        <Header currentPage={currentPage} />
      </div>
      
      {/* 固定フッター */}
      <div className={getFooterClasses()}>
        <Footer currentPage={currentPage} projectId={projectId} />
      </div>
    </>
  );
};

// App内部コンポーネント（useNavigateを使用するため）
const AppContent: React.FC = () => {
  const navigate = useNavigate();

  return (
    <TransitionProvider navigate={navigate}>
      <ViewProvider>
        {/* グローバルトランジションオーバーレイ */}
        <TransitionOverlay />
        
        <div className="App">
          <Routes>
            {/* ホームページ: ヘッダー・フッターありのLayout */}
            <Route 
              path="/" 
              element={
                <>
                  <HeaderFooterWrapper />
                  <Layout>
                    <Home />
                  </Layout>
                </>
              } 
            />
            {/* プロファイルページ: ヘッダー・フッターありの通常レイアウト */}
            <Route 
              path="/profile" 
              element={
                <>
                  <HeaderFooterWrapper />
                  <ProfilePage />
                </>
              } 
            />
            {/* プロジェクト詳細ページ: ヘッダー・フッターありのLayout */}
            <Route
              path="/project/:projectId"
              element={
                <>
                  <HeaderFooterWrapper />
                  <Layout>
                    <ProjectCarousel />
                  </Layout>
                </>
              }
            />
          </Routes>
        </div>
      </ViewProvider>
    </TransitionProvider>
  );
};

// メインAppコンポーネント
function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;